import React from "react";
import { Provider } from "react-redux";
import { store } from "./store";
import Routes from "./Routes";
import AuthInitializer from "./components/AuthInitializer";

function App() {
  return (
    <Provider store={store}>
      <AuthInitializer>
        <Routes />
      </AuthInitializer>
    </Provider>
  );
}

export default App;
